// extracted by mini-css-extract-plugin
export var chip = "_cb-0";
export var filterDropdown = "_cb-5";
export var filterItem = "_cb-6";
export var icon = "_cb-1";
export var removeButton = "_cb-3";
export var removeIcon = "_cb-4";
export var separator = "_cb-2";